var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import * as hive from '@hiveio/hive-js';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
// Costanti
const STEEM_VOTING_MANA_REGENERATION_SECONDS = 432000;
const STEEM_100_PERCENT = 10000;
/* ====================== VOTING POWER ====================== */
export const getVP = (account) => __awaiter(void 0, void 0, void 0, function* () {
    if (!(account === null || account === void 0 ? void 0 : account.name))
        return 0;
    const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
    const chain = String(saved || "STEEM").replace(/^"|"$/g, '').trim().toUpperCase();
    if (chain === "TIME" || chain === "BLURT")
        return 0;
    const manabar = account.voting_manabar;
    if (!manabar)
        return 0;
    const maxMana = Number(manabar.max_mana || manabar.current_mana || 0);
    const currentMana = Number(manabar.current_mana || 0);
    const lastUpdate = Number(manabar.last_update_time || 0);
    if (maxMana === 0)
        return 0;
    const delta = Math.floor(Date.now() / 1000) - lastUpdate;
    const regenerated = (delta * maxMana) / STEEM_VOTING_MANA_REGENERATION_SECONDS;
    let estimated = currentMana + regenerated;
    if (estimated > maxMana)
        estimated = maxMana;
    return Number(((estimated / maxMana) * 100).toFixed(2));
});
/* ====================== DOLLARS PER VOTO ====================== */
export const getVotingDollarsPerAccount = (voteWeight, properties, account, full = false) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const saved = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_CHAIN);
    const chain = String(saved || "STEEM").replace(/^"|"$/g, '').trim().toUpperCase();
    if (chain === "TIME" || chain === "BLURT")
        return '0.00';
    const vp = yield getVP(account);
    const fund = properties.rewardFund;
    const price = properties.price;
    if (!fund || !price)
        return '0.00';
    const getAmount = (asset) => {
        if (typeof asset === 'string')
            return parseFloat(asset.split(' ')[0]) || 0;
        if ((asset === null || asset === void 0 ? void 0 : asset.amount) !== undefined)
            return parseFloat(asset.amount) / 1000;
        return 0;
    };
    const rewardBalance = getAmount(fund.reward_balance);
    const recentClaims = parseFloat(String(fund.recent_claims)) || 1;
    const base = getAmount(price.base);
    const quote = getAmount(price.quote) || 1;
    const hivePrice = base / quote;
    const reserveRate = ((_a = properties.globals) === null || _a === void 0 ? void 0 : _a.vote_power_reserve_rate) || 1;
    const vests = getEffectiveVestingSharesPerAccount(account) * 1000000;
    const power = full ? 10000 : vp * 100;
    const weight = voteWeight * 100;
    const maxDenom = (reserveRate * STEEM_VOTING_MANA_REGENERATION_SECONDS) / 86400;
    let usedPower = (power * weight) / STEEM_100_PERCENT;
    usedPower = Math.round((usedPower + maxDenom - 1) / maxDenom);
    const rshares = (vests * usedPower) / STEEM_100_PERCENT;
    const value = (rshares * rewardBalance) / recentClaims * hivePrice;
    return isNaN(value) ? '0.00' : value.toFixed(2);
});
/* ====================== UTILITY ====================== */
export const getEffectiveVestingSharesPerAccount = (account) => {
    const parseVests = (field) => {
        if (!field)
            return 0;
        const str = String(field);
        return parseFloat(str.replace(/[^0-9.]/g, '')) || 0;
    };
    return (parseVests(account.vesting_shares) +
        parseVests(account.received_vesting_shares) -
        parseVests(account.delegated_vesting_shares));
};
export const getTimeBeforeFull = (vp) => {
    if (vp >= 100)
        return getMessage('popup_utils_full');
    const minutes = (100 - vp) * 72;
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const mins = Math.floor(minutes % 60);
    const parts = [];
    if (days)
        parts.push(`${days} ${days > 1 ? getMessage('days') : getMessage('day')}`);
    if (hours)
        parts.push(`${hours} ${hours > 1 ? getMessage('hours') : getMessage('hour')}`);
    if (mins)
        parts.push(`${mins} ${mins > 1 ? getMessage('minutes') : getMessage('minute')}`);
    return getMessage('full_in', [parts.join(', ')]);
};
/* ====================== MEMO & SIGN ====================== */
export const encodeMemo = (memo, privateKey, receiverPublicKey) => hive.memo.encode(privateKey, receiverPublicKey, memo);
export const decodeMemo = (memo, privateKey) => hive.memo.decode(privateKey, memo);
export const signMessage = (message, privateKey) => {
    const buf = Buffer.isBuffer(message) ? message : Buffer.from(message);
    return hive.auth.Signature.signBuffer(buf, privateKey).toHex();
};
/* ====================== FALLBACK SEMPLICI (NO CONFLITTI DI TIPO) ====================== */
export const getAccountPrice = () => __awaiter(void 0, void 0, void 0, function* () { return 0; });
export const getCurrentMedianHistoryPrice = () => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        base: '1.000 HIVE',
        quote: '1.000 HBD',
    });
});
// RewardFund con SOLO i campi esistenti nel tipo reale
export const getRewardFund = () => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        id: 0,
        reward_balance: '0.000 STEEM',
        recent_claims: '1',
        last_update: new Date().toISOString(),
        content_constant: '2000000000000',
        author_reward_curve: 'linear',
        curation_reward_curve: 'linear',
        // Solo campi presenti nel tipo reale
    });
});
export const isLayer1Token = (token) => ["STEEM", "SBD", "HIVE", "HBD", "BLURT"].includes(token);
/* ====================== ESPORTAZIONE ====================== */
const SteemUtils = {
    getVP,
    getVotingDollarsPerAccount,
    getTimeBeforeFull,
    encodeMemo,
    decodeMemo,
    signMessage,
    getAccountPrice,
    getCurrentMedianHistoryPrice,
    getRewardFund,
    getEffectiveVestingSharesPerAccount,
    isLayer1Token,
};
export default SteemUtils;
